import 'bootstrap/dist/css/bootstrap.min.css';
import { observer, Provider } from 'mobx-react';
import DevTools from 'mobx-react-devtools';
// Import styles
import 'normalize.css';
import React, { Component, PropTypes } from 'react';
import 'styles/global.scss';
// Import App
import App from './App';

/**
 *  AppContainer index component for:
 *  - Importing global CSS styles
 *  - Injecting Mobx Store Provider
 *  - Injecting Mobx DevTools
 *  - Injecting DragDropContext
 *  - Importing App component
 *
 *  NOTE: hot reloading is not working for this component
 *  App component is the one managing routes
 *
 *  DO NOT CHANGE UNLESS NECESSARY!!!
 */
@observer
export default class AppContainer extends Component {
  render() {
    return (
      <Provider {...this.props.stores}>
        <div >
          {
            this.props.stores.MediahubStore.isDev
              ? (
                <DevTools position={{ bottom: 0, left: 20 }} />
              )
              : null
          }
          <App />
        </div >
      </Provider >
    );
  }
}

AppContainer.propTypes = {
  stores: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/containers/AppContainer/index.js